<template>
  <nav class="navbar is-fixed-top" :class="{'is-hidden': !navVis}" role="navigation" aria-label="main navigation">
    <div class="container">
      <div class="navbar-brand">
        <router-link class="navbar-item" to="/">
          <img alt="NestEgg Logo" id="navbarLogo" src="../assets/images/ne_logo.svg" width="200" />
        </router-link>
        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          @click="isOpen = !isOpen"
          :class="{'is-active': isOpen}"
          data-target="navbarMain"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarMain" class="navbar-menu" :class="{'is-active': isOpen}">

        <div class="navbar-start is-uppercase has-text-weight-medium">

          <router-link class="navbar-item" :class="{'is-active': $route.path === '/sell-with-us'}" to="/sell-with-us">Sell with us</router-link>

          <router-link class="navbar-item" :class="{'is-active': $route.path === '/for-agents'}" to="/for-agents">For Agents</router-link>

          <router-link class="navbar-item" :class="{'is-active': $route.path === '/about-us'}" to="/about-us">About NestEgg</router-link>

          <a class="navbar-item" href="http://listings.mynestegg.co.za/">View our listings</a>

          <router-link class="navbar-item is-hidden-desktop-only is-hidden-widescreen-only" :class="{'is-active': $route.path === '/contact-us'}" to="/contact-us">Contact us</router-link>

          <router-link class="navbar-item is-hidden-desktop-only is-hidden-widescreen-only" :class="{'is-active': $route.path === '/faqs'}" to="/faqs">Read our faqs</router-link>

          <div class="navbar-item has-dropdown is-hoverable is-hidden-touch is-hidden-fullhd">
            <a class="navbar-link">More</a>

            <div class="navbar-dropdown">
              <router-link class="navbar-item" to="/contact-us">Contact us</router-link>
              <router-link class="navbar-item" to="/faqs">Read our faqs</router-link>
            </div>

          </div>

        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <router-link class="button is-primary is-rounded" to="/contact-me">Contact Me</router-link>
          </div>
        </div>

      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data: function() {
    return {
      isOpen: false
    }
  },
  props: {
    navVis: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    $route() {
      this.isOpen = false;
    }
  }
}
</script>

<style lang="scss">
@import '../assets/sass/colours.scss';

#navbarLogo {
  max-height: unset;
}

.navbar-start {
  margin-left: 4rem;
}

.navbar-item {
  font-weight: 600;
  font-size: 0.7em;
}

.navbar-item:hover, .navbar-link:hover {
  color: $primary !important;
}

.navbar-item {
    &.is-hoverable:hover {
        .navbar-dropdown {
            display: block;
        }
    }
}
</style>